import { memo } from "react";
import ChargeQtyAdjVesselTablePanel from "./Table/ChargeQtyAdjVesselTablePanel";

const ChargeQtyAdjVesselContent:React.FC = () => {
        return <div className={`main-comp-wrapper`} style={{width:"60vw", height:"69vh"}}>
                <ChargeQtyAdjVesselTablePanel/>
        </div>
}

export default memo(ChargeQtyAdjVesselContent);